import { render, staticRenderFns } from "./BrokerCardPerformance.vue?vue&type=template&id=3575c36c&scoped=true"
import script from "./BrokerCardPerformance.vue?vue&type=script&lang=js"
export * from "./BrokerCardPerformance.vue?vue&type=script&lang=js"
import style0 from "./BrokerCardPerformance.vue?vue&type=style&index=0&id=3575c36c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3575c36c",
  null
  
)

export default component.exports